// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__kkjqW","tab":"ProcedureTabs_tab__dGcLv"};